let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f0D0P")).then(() => parcelRequire('6N55R'));